<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            new fields.Input({
              label: 'Opis',
              type: 'textarea',
              modelPath: [this, 'form', 'description']
            }),
            new fields.Switch({
              label: 'Rozwijalny',
              modelPath: [this, 'form', 'is_expandable']
            }),
            {
              component: 'h3',
              innerText: 'Wiersze'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['left_column']),
                fields: [
                  new fields.Input({
                    label: 'Lewa kolumna',
                    modelPath: [this, 'form', 'items', i, 'left_column'],
                    required: true
                  }),
                  new fields.Input({
                    label: 'Prawa kolumna',
                    modelPath: [this, 'form', 'items', i, 'right_column'],
                    required: true
                  }),
                  new fields.Switch({
                    label: 'Wyróżniony wiersz',
                    modelPath: [this, 'form', 'items', i, 'is_highlighted']
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
